export default "__VITE_ASSET__d17e9fe2__"